import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { Button, Flex, type MantineSize, Text } from '@mantine/core';
import Link from 'next/link';
import classes from './Button.module.css';
export type CarouselControlProps = {
  link: string;
  visible?: MantineSize | (string & {}) | undefined;
  hidden?: MantineSize | (string & {}) | undefined;
  handlePrev?: () => void;
  handleNext?: () => void;
};
export const CarouselControl: React.FC<CarouselControlProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Flex gap={{
    base: 4,
    md: 8
  }} align="center" visibleFrom={props.visible} hiddenFrom={props.hidden}>
      <Text component={Link} href={props.link} c="var(--text-dark)" tt="uppercase" fz={{
      base: 10,
      md: 11
    }} fw="bold">
        {i18n._('view all')}
      </Text>
      <Button classNames={{
      root: classes.btnControl
    }} onClick={props.handlePrev}>
        <Icons className="icon-pr-flat-arrow-left" fontSize={24} />
      </Button>
      <Button classNames={{
      root: classes.btnControl
    }} onClick={props.handleNext}>
        <Icons className="icon-pr-flat-arrow-right" fontSize={24} />
      </Button>
    </Flex>;
};